import type { TableColumnType } from 'components/editor/grid/reduxStore/table.types';
import { ColumnTypeIdentifier } from 'components/editor/grid/reduxStore/table.types';

export const defaultRowMeta = {
  __reorder__: 'Row',
};

export const NUMBER_COLUMNS_ALLOWING_PRICING = 3;

export const defaultColumnMeta: TableColumnType = {
  editable: true,
  headerName: 'Text',
  columnType: ColumnTypeIdentifier.TEXT,
  headerAlign: 'center',
  type: 'string',
  field: 'default',
};

export const initialColumnWidth = 333;
export const initialPricingColumnWidth = 180;

export function calculateInitialColumnWidths(columnCount: number, availableWidth: number): number[] {
  if (columnCount <= 0 || availableWidth <= 0 || !Number.isFinite(availableWidth)) {
    return [];
  }

  const baseWidth = Math.floor(availableWidth / columnCount);
  const remainder = availableWidth - baseWidth * columnCount;

  const widths = Array<number>(columnCount).fill(baseWidth);
  widths[columnCount - 1] += remainder;
  return widths;
}
